import React, { useState } from 'react';
import { Button, Flex } from 'antd';
import { faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MSTeamsEntity, MSTeamsUser } from 'jf/api';
import { DevExButton } from 'jf/components/DevExButton';
import { getMsteamsImageSrc, MSTeamsEntityCard } from 'jf/components/MSTeamsEntityCard';

import { RespondentDetailsDrawers, TargetType } from '../RespondentDetailsDrawer';

type MSTeamsEntityDisplayProps = {
  msteamsUser: MSTeamsUser;
  entityType: MSTeamsEntity.type;
  onDelete?: () => void;
  previewVersion?: boolean;
};

export const MSTeamsEntityDisplay: React.FC<MSTeamsEntityDisplayProps> = ({
  msteamsUser,
  entityType,
  onDelete,
  previewVersion = false,
}) => {
  const [detailsDrawerOpen, setDetailsDrawerOpen] = useState<boolean>(false);
  const imageSrc = getMsteamsImageSrc(msteamsUser.image);

  return (
    <>
      <RespondentDetailsDrawers
        open={detailsDrawerOpen}
        onClose={() => setDetailsDrawerOpen(false)}
        targetType={TargetType.MSTeamsUser}
        email={msteamsUser.email}
        realName={msteamsUser.name}
        userName={msteamsUser.displayName}
        profilePhotoSrc={imageSrc}
      />
      <Button
        style={{
          border: previewVersion ? 'none' : undefined,
          width: '100%',
          height: 'auto',
        }}
        type="default"
        onClick={() => !previewVersion && setDetailsDrawerOpen(true)}
        icon={
          onDelete && (
            <DevExButton
              icon={<FontAwesomeIcon icon={faTrash} />}
              onClick={(e) => {
                e.stopPropagation();
                onDelete();
              }}
            />
          )
        }
        iconPosition="end"
      >
        <Flex style={{ width: '100%', padding: 8 }} align="center" justify="space-between">
          <MSTeamsEntityCard
            name={msteamsUser.name}
            displayName={msteamsUser.displayName}
            imageBytes={msteamsUser.image}
          />
        </Flex>
      </Button>
    </>
  );
};
